<template>
    <v-row>
      <v-col
        cols="12"
        px="4"
        pt="2"
        my="3"
      >
        <h2 class="headline">Logs</h2>
        <br>
        <div
          v-scroll="handleScroll"
        >
          <v-list>
            <dataset-log-card
            v-for="(row, index) in logs"
            :key="index"
            :log="row"
            />
          </v-list>
        </div>
      </v-col>
    </v-row>
</template>

<script>
import DatasetLogCard from "./DatasetLogCard";
import SingerService from "./services/SingerService";
import axios from "axios";

export default {
  props: {
    logs: {
      type: Array,
      default: null,
    },
  },
  components: {
    DatasetLogCard,
  },
  data () {
    return {
      tap_id:null,
    }
  },
  methods: {
    test() {
      this.dialog = true
    },
    handleScroll: function (evt, el) {
      if (window.scrollY > 50) {
        el.setAttribute(
          'style',
          'opacity: 1; transform: translate3d(0, -10px, 0)'
        )
      }
      return window.scrollY > 100
    },
  }
}
</script>
